import {h, Fragment} from "preact"
import { usePagination, useActions } from "@nosto/preact"
import Icon from "./elements/Icon"

function PageLink({ onClick, href, className, ariaLabel, children }) {
    return (
        <a
            class={`ns-page-link ns-relative ns-flex ns-flex-nowrap ns-items-center ns-justify-center ${className}`}
            href={href}
            aria-label={ariaLabel}
            onClick={onClick}
        >
            {children}
        </a>
    )
}

export default function Pagination() {
    const { prev, first, pages, last, next } = usePagination({
        width: 5
    })

    const { updateSearch, simulateUpdateSearch } = useActions()

    function pageLinkProps({ from }) {
        return {
            onClick: e => {
                e.preventDefault()
                updateSearch({ products: { from } })
                scrollTo(0, 0)
            },
            href: simulateUpdateSearch({ products: { from } }).url
        }
    }

    return (
        <nav class="ns-pagination">
            <ol class="ns-flex ns-flex-nowrap ns-items-center ns-justify-center">
                {prev && (
                    <li>
                        <PageLink {...pageLinkProps(prev)} className="ns-previous" ariaLabel="Previous page">
                            <svg class="ns-prev-arrow ns-block" aria-hidden="true" focusable="false" role="presentation" width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1.25L7 6.25L1 11.25" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span class="sr-only visually-hidden">Previous page</span>
                        </PageLink>
                    </li>
                )}

                {first && (
                    <>
                        <li>
                            <PageLink {...pageLinkProps(first)} ariaLabel="First page">
                                {first.page}
                            </PageLink>
                        </li>
                        <li><span class="ns-block ns-pagination-spacer ns-flex ns-items-center ns-justify-center ns-flex-nowrap">...</span></li>
                    </>
                )}

                {pages.map(page => (
                    <li key={page.page} class={`${page.current ? "ns-active" : ""}`}>
                        <PageLink ariaLabel={`${page.page} page`} {...pageLinkProps(page)}>{page.page}</PageLink>
                    </li>
                ))}

                {last && (
                    <>
                        <li><span class="ns-block ns-pagination-spacer ns-flex ns-items-center ns-justify-center ns-flex-nowrap">...</span></li>
                        <li>
                            <PageLink {...pageLinkProps(last)} ariaLabel="Last page">{last.page}</PageLink>
                        </li>
                    </>
                )}

                {next && (
                    <li>
                        <PageLink {...pageLinkProps(next)} className="ns-next" ariaLabel="Next page">
                            <svg class="ns-next-arrow ns-block" aria-hidden="true" focusable="false" role="presentation" width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1.25L7 6.25L1 11.25" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span class="sr-only visually-hidden">Next page</span>
                        </PageLink>
                    </li>
                )}
            </ol>
        </nav>
    )
}
